/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";

// PrimeNG imports
import { MessageService, MenuItem } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { InputSwitchModule } from "primeng/inputswitch";
import { MenuModule } from "primeng/menu";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SkeletonModule } from "primeng/skeleton";
import {
  TableModule,
  TableRowCollapseEvent,
  TableRowExpandEvent,
} from "primeng/table";
import {
  TableSkeletonRowsComponent,
  SkeletonColumnConfig,
  SKELETON_PRESETS,
} from "../../../../shared/components/table-skeleton";
import { TagModule } from "primeng/tag";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";

// Our interfaces
import {
  PagedResult,
  PageEvent,
  QuickLinkListItem,
  QuickLinkActionType,
  QuickLinkStatus,
  SortEvent,
  UsageLimitType,
} from "../../interfaces/quick-link-list-item.interface";
import { PAGE_SIZE_OPTIONS } from "../../interfaces/quick-links-filter.interface";

// Display helpers
import {
  formatUsageDisplay,
  formatUtcDateForDisplay,
  getActionTypeLabel,
  getUsageLimitTypeLabel,
  hasReachedUsageLimit,
  isQuickLinkExpired,
} from "../../utils/enum-display.helpers";

/**
 * Quick Links Table Component
 * PrimeNG p-table implementation with action menus
 */
@Component({
  selector: "app-quick-links-table",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    CheckboxModule,
    InputSwitchModule,
    MenuModule,
    TagModule,
    ToastModule,
    TooltipModule,
    ProgressSpinnerModule,
    SkeletonModule,
    TableSkeletonRowsComponent,
  ],
  templateUrl: "./quick-links-table.component.html",
  styleUrl: "./quick-links-table.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickLinksTableComponent implements OnInit {
  // Input/Output pattern
  @Input() data: PagedResult<QuickLinkListItem> | null = null;
  @Input() loading = false;
  @Input() scrollHeight = "flex";

  @Output() sortChanged = new EventEmitter<SortEvent>();
  @Output() pageChanged = new EventEmitter<PageEvent>();
  @Output() rowAction = new EventEmitter<{
    action: string;
    item: QuickLinkListItem;
  }>();

  // ViewChild references
  @ViewChild("contextMenu") contextMenu: any;

  // Component state
  currentContextItem: QuickLinkListItem | null = null;
  rowMenuItems: MenuItem[] = [];

  // Row expansion state
  expandedRows: { [key: string]: boolean } = {};

  // Expose page size options for template
  readonly pageSizeOptions = [...PAGE_SIZE_OPTIONS];

  // Skeleton columns configuration
  readonly skeletonColumns: SkeletonColumnConfig[] =
    SKELETON_PRESETS.quickLinks;

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    this.initializeRowMenuItems();
  }

  /**
   * Initialize row action menu items
   * Base initialization - actual menu items are built dynamically per row
   */
  private initializeRowMenuItems(): void {
    this.rowMenuItems = [];
  }

  /**
   * Build dynamic menu items based on the quick link item
   * Generate Token is only shown for single-use links (usageLimitType === 2)
   * Delete is hidden for already deleted items (status === 2)
   */
  private buildMenuItemsForItem(item: QuickLinkListItem): MenuItem[] {
    const menuItems: MenuItem[] = [
      {
        label: "Edit",
        icon: "pi pi-pencil",
        command: () => {
          this.rowAction.emit({
            action: "edit",
            item: item,
          });
        },
      },
      {
        label: "View Metrics",
        icon: "pi pi-chart-line",
        command: () => {
          this.rowAction.emit({
            action: "viewMetrics",
            item: item,
          });
        },
      },
    ];

    // COMMENTED OUT: API not ready yet
    // Add "Generate Token" only for single-use links (usageLimitType === 2)
    // if (item.usageLimitType === 2) {
    //   menuItems.push({
    //     label: "Generate Token",
    //     icon: "pi pi-key",
    //     command: () => {
    //       this.rowAction.emit({
    //         action: "generateToken",
    //         item: item,
    //       });
    //     },
    //   });
    // }

    // Only show delete option if item is not already deleted (status !== 2)
    if (item.status !== 2) {
      // Add separator before delete
      menuItems.push({ separator: true });

      // Add delete action
      menuItems.push({
        label: "Delete",
        icon: "pi pi-trash",
        styleClass: "p-menuitem-danger",
        command: () => {
          this.rowAction.emit({
            action: "delete",
            item: item,
          });
        },
      });
    } else {
      // Show permanent delete option for already deleted items (status === 2)
      menuItems.push({ separator: true });

      menuItems.push({
        label: "Permanent Delete",
        icon: "pi pi-trash",
        styleClass: "p-menuitem-danger",
        command: () => {
          this.rowAction.emit({
            action: "permanentDelete",
            item: item,
          });
        },
      });
    }

    return menuItems;
  }

  /**
   * Handle table sorting
   */
  onSort(event: any): void {
    const sortEvent: SortEvent = {
      field: event.field,
      order: event.order,
    };
    this.sortChanged.emit(sortEvent);
  }

  /**
   * Handle page change
   */
  onPageChange(event: any): void {
    const pageEvent: PageEvent = {
      first: event.first,
      rows: event.rows,
      page: event.page,
      pageCount: event.pageCount,
    };
    this.pageChanged.emit(pageEvent);
  }

  /**
   * Show context menu for a row
   * Dynamically builds menu items based on the item's properties
   */
  showContextMenu(event: Event, item: QuickLinkListItem): void {
    this.currentContextItem = item;
    // Build dynamic menu items based on the item
    this.rowMenuItems = this.buildMenuItemsForItem(item);
    this.contextMenu.toggle(event);
  }

  /**
   * Get status label (delegates to helper)
   */
  getStatusLabel(status: QuickLinkStatus): string {
    const labels: Record<number, string> = {
      0: "Disabled",
      1: "Enabled",
      2: "Deleted",
    };
    return labels[status] || "Unknown";
  }

  /**
   * Get status severity for p-tag
   * Returns PrimeNG severity values directly for proper tag styling
   */
  getStatusSeverity(
    status: QuickLinkStatus,
  ): "success" | "secondary" | "info" | "warn" | "danger" | "contrast" {
    switch (status) {
      case 0: // Disabled
        return "secondary"; // Grey
      case 1: // Enabled
        return "success"; // Green
      case 2: // Deleted
        return "danger"; // Red
      default:
        return "secondary";
    }
  }

  /**
   * Get action type display label (delegates to helper)
   */
  getActionTypeLabel(actionType: QuickLinkActionType): string {
    return getActionTypeLabel(actionType);
  }

  /**
   * Get action type icon
   * Returns the PrimeNG icon class for the given action type
   */
  getActionTypeIcon(actionType: QuickLinkActionType): string {
    switch (actionType) {
      case 0: // Resume
        return "pi pi-play";
      case 1: // Pause
        return "pi pi-pause";
      case 2: // Process Now
        return "pi pi-forward";
      case 3: // Reactivate
        return "pi pi-refresh";
      default:
        return "pi pi-question-circle";
    }
  }

  /**
   * Get usage limit type display label (delegates to helper)
   */
  getUsageLimitTypeLabel(usageLimitType: UsageLimitType): string {
    return getUsageLimitTypeLabel(usageLimitType);
  }

  /**
   * Get usage limit type severity
   */
  getUsageLimitTypeSeverity(
    usageLimitType: UsageLimitType,
  ): "success" | "secondary" | "info" | "warn" | "danger" | "contrast" {
    switch (usageLimitType) {
      case 0: // SingleUse
        return "warn";
      case 1: // LimitedUse
        return "info";
      case 2: // Unlimited
        return "success";
      default:
        return "secondary";
    }
  }

  /**
   * Format usage display (delegates to helper)
   */
  getUsageDisplay(item: QuickLinkListItem): string {
    return formatUsageDisplay(
      item.usageLimitType,
      item.currentUsageCount,
      item.maxUses,
    );
  }

  /**
   * Check if usage limit is reached (delegates to helper)
   */
  isUsageLimitReached(item: QuickLinkListItem): boolean {
    return hasReachedUsageLimit(
      item.usageLimitType,
      item.currentUsageCount,
      item.maxUses,
    );
  }

  /**
   * Calculate available uses for limited use links
   * Returns null if unlimited or single-use
   */
  getAvailableUses(item: QuickLinkListItem): number | null {
    if (item.usageLimitType !== 1) return null; // Only for LimitedUse (1)
    if (!item.maxUses) return null;
    return Math.max(0, item.maxUses - item.currentUsageCount);
  }

  /**
   * Calculate usage percentage for limited use links
   * Returns null if unlimited or single-use
   */
  getUsagePercentage(item: QuickLinkListItem): number | null {
    if (item.usageLimitType !== 1) return null; // Only for LimitedUse (1)
    if (!item.maxUses || item.maxUses === 0) return null;
    return Math.round((item.currentUsageCount / item.maxUses) * 100);
  }

  /**
   * Check if link is approaching usage limit (80%+)
   */
  isApproachingLimit(item: QuickLinkListItem): boolean {
    const percentage = this.getUsagePercentage(item);
    if (percentage === null) return false;
    return percentage >= 80 && percentage < 100;
  }

  /**
   * Get usage status color class
   * Returns color classes for success/warning/danger states
   */
  getUsageColorClass(item: QuickLinkListItem): string {
    if (item.usageLimitType !== 1) return ""; // Only for LimitedUse (1)

    if (this.isUsageLimitReached(item)) {
      return "text-red-600 font-bold";
    }
    if (this.isApproachingLimit(item)) {
      return "text-orange-600 font-semibold";
    }
    return "text-green-600 font-medium";
  }

  /**
   * Get usage status icon
   * Returns PrimeNG icon class based on usage state
   */
  getUsageIcon(item: QuickLinkListItem): string {
    if (item.usageLimitType !== 1) return ""; // Only for LimitedUse (1)

    if (this.isUsageLimitReached(item)) {
      return "pi pi-times-circle";
    }
    if (this.isApproachingLimit(item)) {
      return "pi pi-exclamation-triangle";
    }
    return "pi pi-check-circle";
  }

  /**
   * Get detailed usage tooltip text
   */
  getUsageTooltip(item: QuickLinkListItem): string {
    if (item.usageLimitType === 2) {
      return "Unlimited uses - No restrictions";
    }

    if (item.usageLimitType === 0) {
      return item.currentUsageCount > 0
        ? "Single use - Already used"
        : "Single use - Not yet used";
    }

    // Limited use (1)
    const available = this.getAvailableUses(item);
    const percentage = this.getUsagePercentage(item);

    if (this.isUsageLimitReached(item)) {
      return `Usage limit reached - ${item.currentUsageCount} of ${item.maxUses} uses (100%)`;
    }

    if (this.isApproachingLimit(item)) {
      return `Approaching limit - ${item.currentUsageCount} used, ${available} remaining (${percentage}%)`;
    }

    return `${item.currentUsageCount} used, ${available} available (${percentage}%)`;
  }

  /**
   * Toggle status between enabled/disabled
   * Emits to parent which will handle the API call
   */
  onToggleStatus(item: QuickLinkListItem, event: any): void {
    // event.checked contains the new toggle state (true = enabled, false = disabled)
    const newStatus: 0 | 1 = event.checked ? 1 : 0;
    console.log("Status toggle:", {
      item: item.name,
      currentStatus: item.status,
      newStatus,
    });
    this.rowAction.emit({
      action: "statusToggle",
      item: { ...item, status: newStatus },
    });
  }

  /**
   * Get the checked state for the toggle switch
   * Status: 0=Disabled, 1=Enabled, 2=Deleted
   */
  getStatusChecked(status: 0 | 1 | 2): boolean {
    return status === 1; // true if enabled
  }

  /**
   * Toggle one-time use setting
   * Emits to parent which will handle the API call
   *
   * Behavior:
   * - When checking (true): Set to SingleUse (0) with maxUses = 1
   * - When unchecking (false): Set to LimitedUse (1) with maxUses = 100 (default)
   */
  onToggleOneTimeUse(item: QuickLinkListItem, event: any): void {
    // event.checked contains the new toggle state (true = single use, false = not single use)
    let newUsageLimitType: UsageLimitType;
    let newMaxUses: number | null;

    if (event.checked) {
      // Checking: Convert to SingleUse
      newUsageLimitType = 0; // SingleUse
      newMaxUses = 1;
    } else {
      // Unchecking: Convert to LimitedUse with default of 100 uses
      newUsageLimitType = 1; // LimitedUse
      newMaxUses = 100;
    }

    console.log("One-time use toggle:", {
      item: item.name,
      currentUsageLimitType: item.usageLimitType,
      currentMaxUses: item.maxUses,
      newUsageLimitType,
      newMaxUses,
    });

    this.rowAction.emit({
      action: "oneTimeUseToggle",
      item: { ...item, usageLimitType: newUsageLimitType, maxUses: newMaxUses },
    });
  }

  /**
   * Format UTC date for display (delegates to helper)
   */
  formatDate(utcDateString: string | null): string {
    return formatUtcDateForDisplay(utcDateString);
  }

  /**
   * Check if link is expired (delegates to helper)
   */
  isExpired(item: QuickLinkListItem): boolean {
    return isQuickLinkExpired(item.expiredUtc);
  }

  /**
   * Check if link is single-use
   * UsageLimitType: 0=SingleUse, 1=LimitedUse, 2=Unlimited
   */
  isSingleUse(item: QuickLinkListItem): boolean {
    return item.usageLimitType === 0;
  }

  /**
   * Check if we have data to display
   */
  hasData(): boolean {
    return !!(this.data && this.data.data && this.data.data.length > 0);
  }

  /**
   * Event handler for row expansion
   */
  onRowExpand(event: TableRowExpandEvent): void {
    // Optional: Add any custom logic when row expands
  }

  /**
   * Event handler for row collapse
   */
  onRowCollapse(event: TableRowCollapseEvent): void {
    // Optional: Add any custom logic when row collapses
  }

  /**
   * Toggle row expansion when clicking on the row
   * Used for mobile card click-to-expand functionality
   */
  toggleRowExpansion(item: QuickLinkListItem): void {
    const key = item.id.toString();
    if (this.expandedRows[key]) {
      delete this.expandedRows[key];
      this.expandedRows = { ...this.expandedRows }; // Trigger change detection
    } else {
      // Single expansion mode - clear others first
      this.expandedRows = { [key]: true };
    }
  }

  /**
   * Get redirect type label
   */
  getRedirectTypeLabel(redirectType: number): string {
    switch (redirectType) {
      case 0:
        return "Thank You Page";
      case 1:
        return "V2 Portal";
      case 2:
        return "Custom URL";
      default:
        return "Unknown";
    }
  }

  /**
   * Parse UTM parameters from JSON string
   */
  parseUtmParams(utmParamsJson: string | null | undefined): string {
    if (!utmParamsJson) return "None";
    try {
      const params = JSON.parse(utmParamsJson);
      const entries = Object.entries(params)
        .filter(([_, value]) => value)
        .map(([key, value]) => `${key}=${value}`);
      return entries.length > 0 ? entries.join(", ") : "None";
    } catch {
      return "Invalid format";
    }
  }

  /**
   * Copy text to clipboard
   * Used in expanded row template for copying template URLs
   */
  // Force recompilation - v2
  copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.messageService.add({
          severity: "success",
          summary: "Copied",
          detail: "URL copied to clipboard",
          life: 2000,
        });
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to copy URL",
          life: 3000,
        });
      });
  }
}
